export default {
      id: "facebook-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#facebook-usage",
      toString: function () {
        return this.url;
      }
    }